import React from 'react';
import { OFFER_ANCHOR } from '../data/constants';
const links = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-charcoal px-4 py-6" data-id="element-55" data-mp="3ghc508vl1fre">
      <div className="mx-auto max-w-3xl text-center" data-id="element-56" data-mp="32onk11rpbm8f">
        <p className="font-display text-[0.7rem] font-bold uppercase tracking-wide text-lightGray sm:text-xs" data-id="element-57" data-mp="32m1bozwzl2p5">
          © 2026 METAL FABRICATION READY™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-2 max-w-2xl text-[0.7rem] font-medium leading-snug text-steelGray sm:text-xs" data-id="element-58" data-mp="3uftpzyu3se5m">
          METAL FABRICATION READY™ provides project plans and reference materials for informational and
          fabrication-planning purposes. Users are responsible for verifying dimensions, materials, structural
          requirements, applicable codes and safe fabrication practices before constructing any project.
        </p>
        <ul className="mt-2.5 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-59" data-mp="2eyt8cnj4c3pr">
          {links.map(link => <li key={link} className="flex items-center gap-2" data-id="element-60" data-mp="3labovo69tsmo">
              <a href={OFFER_ANCHOR} className="text-[0.7rem] font-semibold text-lightGray underline decoration-steelGray underline-offset-4 transition-colors duration-150 ease-out hover:text-white sm:text-xs" data-id="element-61" data-mp="3gapfjptkcwj5">
                {link}
              </a>
              {link !== links[links.length - 1] ? <span aria-hidden="true" className="text-steelGray" data-id="element-62" data-mp="817c224r7iry">
                  •
                </span> : null}
            </li>)}
        </ul>
      </div>
    </footer>;
}